import {
  Component,
  computed,
  input,
  output,
  viewChildren,
} from '@angular/core';
import { Element } from '../element/element';
import {
  ComposedPage,
  InteractionTypes,
} from '@hyper-inferno/survey-elements-core-utils';
import { PluginHost } from '../plugin-host/plugin-host';
import { ComposedSurveyPlugin } from '@hyper-inferno/survey-elements-core';

@Component({
  selector: 'lib-page',
  imports: [Element, PluginHost],
  templateUrl: './page.html',
  styleUrl: './page.css',
})
export class Page {

  protected readonly pagePlugins = computed<ComposedSurveyPlugin[]>(() => {
    return this.page().pagePlugins || [];
  });

  pageAction = output<{ type: InteractionTypes; payload?: any }>();

  onNextClick() {
    this.pageAction.emit({ type: InteractionTypes.SUBMIT });
  }
  goForward() {
    this.pageAction.emit({ type: InteractionTypes.SUBMIT });
  }
  goBack() {
    this.pageAction.emit({ type: InteractionTypes.SWITCH, payload: false });
  }
  page = input.required<ComposedPage>();
  isValid = input.required<boolean>();

  private elementRefs = viewChildren(Element);
  onSubmit() { }
}
